module.exports = __webpack_public_path__ + "static/media/okjing.92815262.png";